/**
 * Shared Nav's Implementation of Kebab Casing
 * @param {string} str - string to be transformed
 * @returns {string} - normalized string
 */
export default (str = '') => str.toLowerCase()
  .replace(/[^_a-zA-Z0-9\s+]/g, '')
  .trim()
  .replace(/[_\s]+/g, '-');
